import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFootballTeam, IFootballTeamDetail } from "../../../commons/models/football/interface/i-football-team";
import { IFootballSubTeamDetail } from "../../../commons/models/football/interface/i-football-sub-team";
import { ManageFootballSubTeam } from "../../../commons/models/football/admin/manage-football-sub-team";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";

interface FetchedTeamState {
  fetchedTeam: IFootballTeamDetail | IFootballSubTeamDetail;
}

const initialState: FetchedTeamState = {
  fetchedTeam: new ManageFootballTeam() || new ManageFootballSubTeam(),
};

export const FetchedTeamSlice = createSlice({
  name: "fetchedTeamSlice",
  initialState,
  reducers: {
    setFetchedTeamData: (state, action: PayloadAction<IFootballTeamDetail | IFootballSubTeamDetail>) => {
      state.fetchedTeam = action.payload;
    },

    cleanUpFetchedTeamData: (state) => {
      state.fetchedTeam = new ManageFootballTeam() || new ManageFootballSubTeam();
    },
  },
});

export const { setFetchedTeamData, cleanUpFetchedTeamData } = FetchedTeamSlice.actions;
export default FetchedTeamSlice.reducer;
